module.exports = __webpack_public_path__ + "media/images/vp/icon.rt.white-208ae08841d20df4e01b03e9f3b78249.png";